<template>
	<!-- this component shouldnt have href, we need to update after set up back -->
	<div class="download-item">
		<div class="icon-sec">
			<a @click="download" href="#"><i class="material-icons">attachment</i></a>
		</div>
		<div class="doc-info">
			<div class="header4">{{ title }} {{ isSigned }}</div>
			<div class="header6">{{ type }}</div>
		</div>
	</div>
</template>

<script>
import api from "@/store/utils/api";

export default {
	name: "download-item",
	props: {
		title: String,
		type: String,
		href: String,
		isSigned: Boolean,
	},
	methods: {
		async download() {
			try {
				await api.download(this.href);
			} catch (ex) {
				this.$toast.error("Unable to download the file", { position: "top" });
			}
		},
	},
};
</script>

<style scoped lang="scss">
.download-item {
	padding: 25px 0;
	text-align: left;
	display: flex;
	flex-direction: row;
	align-items: center;
	.icon-sec {
		background: var(--primary);
		border-radius: 25px;
		display: flex;
		justify-content: center;
		align-items: center;
		text-decoration: none;
		list-style: none;
		width: 48px;
		height: 48px;
		a {
			text-decoration: none;
			list-style: none;
			display: flex;
			justify-content: center;
			align-items: center;
			color: white;
			i {
				transform: rotate(-45deg);
			}
		}
	}
	.doc-info {
		padding-left: 15px;
	}
	.header4 {
		color: var(--dark-gray);
	}
	.paragraph {
		color: var(--dark-gray);
		margin-top: 15px;
	}
}
</style>
